<template>
	<div>


		<div id="jobDetails">
			<div class="container">
				<!-- <div class="companyInfo">
				<div class="company_avatar">
					{{schoolInfo.logo}}
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->
			</div>


			<div class="jobInfo">
				<div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						生源详情
					</div>
				</div>

				<div class="chunk">
					<div class="nameContainer">
						<div class="left">
							<div class="name" v-if="nextToken">
								{{info.realname || info.username ||info.username ||''}}
							</div>
							<div class="name" v-else>
								{{info.realname?info.realname.charAt(0)+'同学':info.username?info.username.charAt(0)+'同学':info.name?info.name.charAt(0)+'同学':''}}
								<!-- {{info.realname.charAt(0)+'某某' || info.username.charAt(0)+'某某' || info.name.charAt(0)+'某某' }} -->
							</div>
							<div class="school">
								{{info.academy_name||info.academy_name}} · {{info.major_name||info.major_name}}
							</div>
						</div>
						<div class="right" style="position: relative;" >
							<student-avatar :avatar="info.avatar" :name="info.realname || info.username || info.name"
								:user-id="info.user_id" :gender="info.gender" :size="57" />
							<div class="shortVideo" v-if="introduction_short_video!=''" @click="dialogVisible = true">
								短视频
							</div>
						</div>
					</div>
				</div>
				
				<div class="chunk" v-if="info.tel">
					<div class="nameContainer">
						<div class="left">
							<div class="name" >
								手机
							</div>
							<div class="school" v-if="nextToken">
								{{info.tel}}
							</div>
							<div class="school" v-else>
								{{info.tel.slice(0,3) + '****' + info.tel.slice(-4)}}
							</div>
						</div>
						
					</div>
				</div>

				<div class="chunk">
					<div class="programme">
						<div class="programmeTitle">
							个人职业规划
						</div>
						<div class="tags">
							<div class="item">
								<img src="../img/opt1.png" alt="" />
								<div class="">
									{{info.highest_education || '本科'}}
								</div>
							</div>
							<div class="item" v-if="info.graduation_year">
								<img src="../img/opt2.png" alt="" />
								<div class="">
									{{ info.graduation_year?info.graduation_year:''}}
									<!-- info.level_name || '大四' -->
								</div>
							</div>
							<div class="item" v-if="info.gender && info.gender !== '0'">
								<img src="../img/opt3.jpg" alt="" />
								<div class="">
									{{info.gender===1?'男':'女'}}
								</div>
							</div>
							<div class="item" v-if="info.age !== undefined && info.age !== null && info.age !== ''">
								<img src="../img/opt4.png" alt="" />
								<div class="">
									{{ formatAge(info.age) }}
								</div>
							</div>
						</div>

						<div class="projectMain" v-if="info.career_planning">
							{{info.career_planning}}
						</div>
					</div>
				</div>

				<div class="chunk" v-if="MyDesireList.length>0">
					<div class="intention1">
						<div class="name">
							求职意向
						</div>
						<div class="intentionItem" v-for="(item,index) in MyDesireList" :key="index">
							<div class="left">
								<div class="top">
									<div class="a1">
										[{{item.work_city | replaceWord}}]
									</div>
									<div class="a2">
										{{JSON.parse(item.job_title)[0]}}
									</div>
								</div>
								<div class="bottom">
									<div class="a3">
										{{item.salary_max==0?'面议':item.salary_min+'-'+item.salary_max+'k'}}
									</div>
									<div class="xian1" v-if="item.industry && JSON.parse(item.industry)[0]">

									</div>
									<div class="a4" v-if="item.industry && JSON.parse(item.industry)[0]">
										{{JSON.parse(item.industry)[0]}}
									</div>
								</div>
							</div>
							<div class="right" v-if="item.character_match!=''" @click="opendialogVisible1(index)">
								求职偏好
							</div>
						</div>
					</div>
				</div>

				<div class="chunk" v-if="source==1 && eduExpList.length>0">
					<div class="programme">
						<div class="programmeTitle">教育经历</div>
						<div class="projectMain" v-for="(item,index) in eduExpList" :key="index">
							<div style="font-weight: bold;">{{item.academyName}}<span v-if="item.academyName && item.majorName"> · </span>{{item.majorName}}</div>
							<div>{{item.gradation}}</div>
							<div>{{item.startTime ? item.startTime + ' 至 ' : ''}}{{item.endTime}}</div>
						</div>
					</div>
				</div>

				<div class="chunk" v-if="MyDesireList.length===0">
					<div class="intention">
						<div class="name">
							求职意向
						</div>
						<div class="tags">
							<div class="item" v-if="info.intention_city">
								工作城市：{{String(info.intention_city).replace(/,/g,'，')}}
							</div>
							<div class="item" v-else>
								工作城市：武汉
							</div>
							<div class="item">
								期望职位：{{String(job_title || '').replace(/,/g,'，')||'暂未填写'}}
							</div>
							<div class="item" v-if="info.salary_min || info.salary_max">
								薪资要求：{{info.salary_min+'-'+info.salary_max+'k'}}
							</div>
							<div class="item" v-else>
								薪资要求：面议
							</div>
						</div>
					</div>
				</div>



				<template v-if="source==1 || practice_list.length>0">
					<div class="chunk" v-if="practice_list.length>0">
						<div class="programme">
							<div class="programmeTitle">
								实习/项目经历
							</div>
							<div class="projectMain" v-for="(item,index) in practice_list" :key="index">
								<div class="" style="font-weight: bold;">
									{{item.entry_name}}
								</div>
								<div>
									{{item.role}}
								</div>
								<div class="experienceDescription">
									{{formatExperienceDescription(item.entry_desc)}}
								</div>
								<div>
									{{item.date1}}{{item.date1 && item.date2 ? ' 至 ' : ''}}{{item.date2}}
								</div>

							</div>
						</div>
					</div>
					<div class="chunk" v-else>
						<div class="programme">
							<div class="programmeTitle">
								实习/项目经历
							</div>
							<div class="projectMain">
								暂未填写
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="chunk" v-if="info.practice_experience&&info.practice_experience!=''&&info.practice_experience!='[]'">
						<div class="programme">
							<div class="programmeTitle">
								实习/项目经历
							</div>
							<div class="projectMain experienceDescription">
								{{formatExperienceDescription(info.practice_experience)}}
							</div>
						</div>
					</div>
					<div class="chunk" v-else>
						<div class="programme">
							<div class="programmeTitle">
								实习/项目经历
							</div>
							<div class="projectMain">
								暂未填写
							</div>
						</div>
					</div>
				</template>

				<template v-if="source==1 || social_list.length>0">
					<div class="chunk" v-if="social_list.length>0">
						<div class="programme">
							<div class="programmeTitle">
								校园/活动/科研经历
							</div>
							<div class="projectMain" v-for="(item,index) in social_list" :key="index">
								<template v-if="typeof item === 'object'">
									<div class="" style="font-weight: bold;">{{item.entry_name}}</div>
									<div>{{item.role}}</div>
									<div class="experienceDescription">{{formatExperienceDescription(item.entry_desc)}}</div>
									<div>{{item.date1?item.date1+' 至 ':''}}{{item.date2}}</div>
								</template>
								<div v-else class="experienceDescription">{{formatExperienceDescription(item)}}</div>

							</div>
						</div>
					</div>
					<div class="chunk" v-else>
						<div class="programme">
							<div class="programmeTitle">
								校园/活动/科研经历
							</div>
							<div class="projectMain">
								暂未填写
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="chunk" v-if="info.social_experience&&info.social_experience!='[]'">
						<div class="programme">
							<div class="programmeTitle">
								校园/活动/科研经历
							</div>
							<div class="projectMain experienceDescription">
								{{formatExperienceDescription(info.social_experience)}}
							</div>
						</div>
					</div>
					<div class="chunk" v-else>
						<div class="programme">
							<div class="programmeTitle">
								校园/活动/科研经历
							</div>
							<div class="projectMain">
								暂未填写
							</div>
						</div>
					</div>
				</template>

				<div class="chunk" v-if="source==1 && academic_list.length>0">
					<div class="programme">
						<div class="programmeTitle">学术经历</div>
						<div class="projectMain" v-for="(item,index) in academic_list" :key="index">
							<div style="font-weight: bold;">{{item.entry_name}}</div>
							<div>{{item.role}}</div>
							<div v-html="item.entry_desc"></div>
							<div>{{item.date1 ? item.date1 + ' 至 ' : ''}}{{item.date2}}</div>
						</div>
					</div>
				</div>
				<template v-if="source==1 || award_list.length>0">
					<div class="chunk" v-if="award_list.length>0">
						<div class="programme">
							<div class="programmeTitle">
								所获奖项
							</div>

							<div class="projectMain"
								style="display: flex; align-items: center;justify-content: space-between;"
								v-for="(item,index) in award_list" :key="index">
								<div class="">
									{{item.reward_name}}
								</div>
								<div class="">
									{{item.reward_time || '2021-11-22'}}
								</div>
							</div>
						</div>
					</div>
					<div class="chunk" v-else>
						<div class="programme">
							<div class="programmeTitle">
								所获奖项
							</div>
							<div class="projectMain">
								暂未填写
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="chunk" v-if="info.award_experience">
						<div class="programme">
							<div class="programmeTitle">
								所获奖项
							</div>

							<div class="projectMain">
								{{info.award_experience}}
							</div>
						</div>
					</div>
					<div class="chunk" v-else>
						<div class="programme">
							<div class="programmeTitle">
								所获奖项
							</div>
							<div class="projectMain">
								暂未填写
							</div>
						</div>
					</div>
				</template>
				<div class="chunk">
					<div class="programme">
						<div class="programmeTitle">
							个人技能和兴趣
						</div>
						<div class="projectMain" v-if="interestList.length>0">
							{{interestList.join('、')}}
						</div>
						<div class="projectMain" v-else>
							暂未填写
						</div>
					</div>
				</div>

				<div class="chunk"
					v-if="(personal_works.files&&personal_works.files.length>0) || (personal_works.images&&personal_works.images.length>0) ||(personal_works.tet&&personal_works.tet.length>0)">
					<div class="programme">
						<div class="programmeTitle">
							个人作品
						</div>
						<div class="projectMain">
							<template v-if="personal_works.files&&personal_works.files.length>0">

								<div class="" style="font-weight: bold;margin-bottom: 10px;">
									作品附件
								</div>
								<div class=""
									style="display: flex;align-items: center;margin-bottom: 10px;cursor: pointer;"
									v-for="(item,index) in personal_works.files" :key="index"
									@click="openFile(item.fileUrl)">
									<img style="width: 50px;height: 50px;margin-right: 10px;"
										:src="item.filename.indexOf('.pdf')>-1? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/10/07/v7qfwpbtjlpr1q5c.png':item.filename.indexOf('.doc')>-1?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/10/07/hpfalx8js70aabax.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/10/07/nm8mkwx5o87ura7v.png'"
										alt="" />
									<div class="">
										{{item.filename}}
									</div>
								</div>
							</template>
							<template v-if="personal_works.images&&personal_works.images.length>0">
								<div class="" style="font-weight: bold;margin-bottom: 10px;">
									作品图片
								</div>
								<div class="imgList" style="margin-top: 20px;word-break: break-all;"
									v-if="personal_works.images&&personal_works.images.length>0">
									<img style="cursor: pointer;" :src="item" alt=""
										v-for="(item,index) in personal_works.images" :key="index"
										@click="openFile(item)" />
								</div>
							</template>
							<template v-if="personal_works.tet.length>0">
								<div class="" style="font-weight: bold;margin-bottom: 10px;">
									作品链接
								</div>
								<div class="projectMain">
									<div class=""
										style="margin-bottom: 10px;color:#0084FF;text-decoration:underline;cursor: pointer;"
										v-for="(item,index) in personal_works.tet" :key="index" @click="openFile(item)">
										{{item}}
									</div>
								</div>
							</template>

						</div>
					</div>
				</div>
				<div class="chunk" v-else>
					<div class="programme">
						<div class="programmeTitle">
							个人作品
						</div>
						<div class="projectMain">
							暂未填写
						</div>
					</div>
				</div>

				<div class="chunk" v-if="info.certificate&&info.certificate!=''">
					<div class="programme">
						<div class="programmeTitle">
							资格能力证书
						</div>
						<div class="projectMain">
							{{info.certificate}}
						</div>
					</div>
				</div>
				<div class="chunk" v-if="info.skill">
				<div class="programme">
					<div class="programmeTitle">
						职业技能
					</div>
					<div class="projectMain">
						{{info.skill | replaceWord}}
					</div>
				</div>
			</div>
				<div class="chunk" v-if="filelist.url">
					<div class="programme">
						<div class="programmeTitle">附件简历</div>
						<div class="projectMain">
							<div style="display: flex;align-items: center;margin-bottom: 10px;cursor: pointer;" @click="openResumeFile">
								<img style="width: 50px;height: 50px;margin-right: 10px;" :src="filelist.filename.indexOf('.pdf')>-1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/10/07/v7qfwpbtjlpr1q5c.png' : filelist.filename.indexOf('.doc')>-1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/10/07/hpfalx8js70aabax.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/10/07/nm8mkwx5o87ura7v.png'" alt="" />
								<div>{{filelist.filename}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="chunk" v-else>
					<div class="programme">
						<div class="programmeTitle">附件简历</div>
						<div class="projectMain">暂未填写</div>
					</div>
				</div>
				<!-- <div class="chunk">
				<div class="programme">
					<div class="programmeTitle">
						个人职业规划
					</div>
					<div class="projectMain" v-if="info.career_planning" v-html="info.career_planning">
					</div>
          <div class="projectMain" v-else>
							暂未填写
						</div>
				</div>
			</div> -->

				<!-- <div class="btnContainer" style="opacity: 0;padding-bottom: 50px;">
			
				<el-button type="primary" @click="openChatFrame">立即沟通</el-button>
			</div> -->
				<div style="height: 60px;"></div>
				<div class="btnContainer" style="position: fixed;z-index: 10;left: 180px;bottom: 0;width: 762px;">
					<!-- <div class="btn">
					立即沟通
				</div> -->
					<div style="border: 10px solid #fff;border-radius: 5px;">
						<el-button type="primary" @click="openChatFrame">立即沟通</el-button>
					</div>
				</div>
			</div>

			<el-dialog title="短视频" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
				<div class="" style="display: flex;align-items: center;justify-content: center;">
					<video :src="introduction_short_video" controls style="width: 600px;height:338px"></video>
				</div>
			</el-dialog>

			<div class="elDialog">


				<el-dialog title="求职偏好" :visible.sync="dialogVisible1" width="800px" :before-close="handleClose1">
					<div class="elDialog">
						<div class="searchItem" v-if="multipleSelect1">
							<div class="iptName">
								工作自由度：
							</div>
							<div class="preference">
								{{multipleSelect1}}
							</div>
						</div>
						<div class="searchItem" v-if="multipleSelect2">
							<div class="iptName">
								员工福利：
							</div>
							<div class="preference">
								{{multipleSelect2}}
							</div>
						</div>
						<div class="searchItem" v-if="multipleSelect5">
							<div class="iptName">
								期望通勤时间：
							</div>
							<div class="preference">
								{{multipleSelect5}}分钟
							</div>
						</div>
						<div class="searchItem" v-if="acceptance_of_overtime">
							<div class="iptName">
								加班接受度：
							</div>
							<div class="preference">
								{{acceptance_of_overtime}}
							</div>
						</div>
						<div class="searchItem" v-if="acceptance_of_outwork">
							<div class="iptName">
								出差接受度：
							</div>
							<div class="preference">
								{{acceptance_of_outwork}}
							</div>
						</div>

						<div class="searchItem">
							<div class="iptName">
								求职者最擅长的团队定位（按以下项目从高到低排序）
							</div>
							<div class="preference">
								<div class="" style="margin-bottom: 5px;"
									v-for="(item,index) in questionList1[0].questionItem" :key="index">
									{{item.name}}
								</div>
							</div>
						</div>
						<div class="searchItem">
							<div class="iptName">
								求职者最看重哪些回报?（按以下项目从高到低排序）
							</div>
							<div class="preference">
								<div class="" style="margin-bottom: 5px;"
									v-for="(item,index) in questionList1[1].questionItem" :key="index">
									{{item.name}}
								</div>
							</div>
						</div>
						<!-- div class="" style="font-weight: 400;font-size: 16px;color: #343232;">
					求职者最擅长的团队定位（按以下项目从高到低排序）
				</div>
				<div class="drag">
				</div>
				<div class="" style="font-weight: 400;font-size: 16px;color: #343232;">
					求职者最看重哪些回报?（按以下项目从高到低排序）
				</div>
				<div class="drag">
				</div> -->
					</div>
				</el-dialog>
			</div>
			<div class="chatView">


				<el-dialog :visible.sync="dialogVisiblechatView" :close-on-click-modal="false" :show-close="false"
					@closed='closeElDialog' width="465px">
					<chatView @openImg="openImg" :dataObj='dataObj' ref="sonRef" @closeDialog='closeDialog'
						:openChartView='openChartView'></chatView>
				</el-dialog>
			</div>

		</div>
		<el-dialog :visible.sync="dialogVisibleImg">
			<div id="" class="img-carousel-box">
				<img :src="dialogImageUrl" alt="" mode="heightFix">
			</div>
		</el-dialog>
		<el-dialog title="充值提醒" :visible.sync="resumeRechargeVisible" width="520px" top="50vh" :close-on-click-modal="false" custom-class="resume-recharge-reminder">
			<div class="resume-recharge-reminder__content">您的免费使用额度已到上限，充值后可继续查看简历！</div>
			<div slot="footer" class="resume-recharge-reminder__footer"><el-button @click="resumeRechargeVisible = false">取消</el-button><el-button type="primary" @click="goResumeRecharge">去充值</el-button></div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import Qs from 'qs'
	import chatView from '../components/chatView.vue'
	import studentAvatar from '../components/studentAvatar.vue'
	export default {
		data() {
			return {
				dialogImageUrl: '',
				dialogVisibleImg: false,
				dialogVisiblechatView: false,
				openChartView: false,
				id: 0,
				info: {},
				introduction_short_video: '', //个人介绍短视频
				dialogVisible: false,
				dialogVisible1: false,
				user_id: 0,
				source: 0,


				MyDesireList: [],
			practice_list: [],
			social_list: [],
			academic_list: [],
			eduExpList: [],
			practice_experience: [],
			stylePracticeType: 0,

				award_list: [],

				interestList: [],
				personal_works: {},
				filelist: {},
				resumeRechargeVisible: false,


				acceptance_of_overtime: '',
				acceptance_of_outwork: '',

				multipleSelect1: '',
				multipleSelect2: '',
				multipleSelect5: '',

				questionList1: [{
					title: '期望求职者团队定位/性格，按以下项目从高到低排序',
					questionItem: [{
							name: '--开拓新业务:获得快速的结果、采取行动、喜好挑战',
							idx: 0,
						},
						{
							name: '--团队组织:热情乐观、采取行动、活跃团队气氛',
							idx: 1,
						},
						{
							name: '--运营优化:保证准确性、保持稳定性、对产品流程和细节精益求精',
							idx: 2,
						},
						{
							name: '--稳定执行:给予他人支持、团队精神、吃苦耐劳',
							idx: 3,
						}
					]
				}, {
					title: '公司能满足求职者哪些需求？按以下项目从高到低排序',
					questionItem: [{
							name: '--有话语权的职位、晋升、高薪、荣誉感、胜利感',
							idx: 0,
						},
						{
							name: '--友好密切的同事关系、团建活动、展现才艺的机会',
							idx: 1,
						},
						{
							name: '--发挥专业特长、获取新知识、高质量的工作成果',
							idx: 2,
						},
						{
							name: '--稳定的环境、较少的冲突、诚挚的感谢、合作互助的氛围',
							idx: 3,
						}
					]
				}],
				letter: ['A', 'B', 'C', 'D'],
				job_title: '',
				dataObj: '',
			};
		},
		mounted() {
			let source = sessionStorage.getItem('source') 
			let jobDetailsid = sessionStorage.getItem('jobDetailsid') 
			let jobDetailsuserid = sessionStorage.getItem('jobDetailsuserid') 
			// if (source==0||source==) {
				this.source = source
				// localStorage.removeItem('source')
				if (source == 0) {
					if (jobDetailsid) {
						this.id = jobDetailsid
						this.getUserRecordInfo()
					}
				} else if (source == 1) {
					if (jobDetailsuserid) {
						this.id = jobDetailsid
						this.user_id = jobDetailsuserid
						this.getUserRecordInfoByUserId()
						this.getMyDesireByUserid()
					}
				}else{
					if (jobDetailsuserid) {
						this.id = jobDetailsid
						this.user_id = jobDetailsuserid
						this.getUserRecordInfoByUserId()
						this.getMyDesireByUserid()
					}
				}
			// }
			
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		filters:{
			replaceWord(val) {
				if (val === undefined || val === null) return ''
				if (Array.isArray(val)) return val.join('、')
				return String(val).replace(/,/g, '、')
			}
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		methods: {
			...mapMutations(['setIslogin']),
			formatAge(age) {
				if (age === undefined || age === null || age === '') return ''
				const value = String(age)
				return value.replace(/岁+$/, '') + '岁'
			},
			closeElDialog() {
				this.$refs.sonRef.ParentOpSon();
			},
			openImg(i) {
				this.dialogVisibleImg = true
				this.dialogImageUrl = i
			},
			closeDialog() {
				this.dialogVisiblechatView = false
			},

			schoolJobSend() {
				return new Promise((resolve, reject) => {
					this.$util.post(
						"v2/school_job/get_object_credit", {
							admin_id: this.schoolInfo.admin_id,
							
						},
						(res) => {
							resolve(res)
						}
					)		
					
				})
			},

			async openChatFrame() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				
				let isCommunication = await this.schoolJobSend()
				console.log(isCommunication)
				console.log(this.info.has_send_record)
				if(this.info.has_send_record==0){
					if(isCommunication.data.object_credit<=0){
						// this.$uniapp.toast("试用生源额度已到上限，请联系专属业务员开启！")
						 this.$alert('试用生源联系额度已到上限，请联系专属业务员开启更多的生源沟通！', '提示', {
						          confirmButtonText: '确定',
						          type: 'warning',
						        }).then(() => {
						          return
						        })
						return
					}
				}
				
				
				this.$util.post(
					"v2/school_job/match_by_job_title", {
						admin_id: this.schoolInfo.admin_id,
						job_title: this.info.job_title ? JSON.stringify([this.info.job_title]) : '',
					},
					(res) => {

						if (res.code == 200) {
							let obj = {}
							if (res.data[0]) {
								obj = {
									job_id: res.data[0].id,
									admin_id: res.data[0].admin_id,
									user_id: this.info.user_id,
									to_chat_name: this.info.realname || this.info.username || this.info.username ||
										'',
									to_chat_logo: this.info.avatar || '',
								}
							} else {
								obj = {
									job_id: 1,
									admin_id: this.schoolInfo.admin_id,
									user_id: this.info.user_id,
									to_chat_name: this.info.realname || this.info.username || this.info.username ||
										'',
									to_chat_logo: this.info.avatar || '',
								}
							}

							this.dataObj = JSON.stringify(obj)
							this.dialogVisiblechatView = true
							this.openChartView = true

							setTimeout(() => {
								this.openChartView = false
							}, 3000)
							// this.$router.push({
							// 	path: "/messageManagement",
							// 	query: {
							// 		obj:JSON.stringify(obj)
							// 	},
							// });
						}
					}
				);

			},
			// v2/school_job/my_desire_by_userid
			// https://np.sx985.com/v2/school_job/user_record_info
			opendialogVisible1(index) {
				// this.myDesireIndex = index
				let item = this.MyDesireList[index]
				if (item.work_freedom != '') {
					this.multipleSelect1 = JSON.parse(item.work_freedom).join('、')
				}

				if (item.welfare != '') {
					this.multipleSelect2 = JSON.parse(item.welfare).join('、')
				}

				if (item.commuting_time != '') {
					this.multipleSelect5 = JSON.parse(item.commuting_time).join('、')
				}

				if (item.acceptance_of_overtime != '') {
					this.acceptance_of_overtime = JSON.parse(item.acceptance_of_overtime)[0]
				}

				if (item.acceptance_of_outwork != '') {
					this.acceptance_of_outwork = JSON.parse(item.acceptance_of_outwork)[0]
				}


				if (item.character_match !== '') {
					let arr1 = JSON.parse(item.character_match)[0].split('')
					let sortArr = []
					arr1.forEach((item) => {
						sortArr.push(this.letter.indexOf(item))
					})
					let questionList1 = JSON.parse(JSON.stringify(this.questionList1[0].questionItem))
					sortArr.forEach((item, index) => {
						this.questionList1[0].questionItem[index] = questionList1[item]
					})
				}


				if (item.job_match !== '') {
					let arr2 = JSON.parse(item.job_match)[0].split('')
					let sortArr1 = []
					arr2.forEach((item) => {
						sortArr1.push(this.letter.indexOf(item))
					})

					let questionList2 = JSON.parse(JSON.stringify(this.questionList1[1].questionItem))
					sortArr1.forEach((item, index) => {
						this.questionList1[1].questionItem[index] = questionList2[item]
					})
				}
				this.dialogVisible1 = true
			},
			handleClose() {
				this.dialogVisible = false
			},
			handleClose1() {
				this.dialogVisible1 = false
			},
			getMyDesireByUserid() {
				this.$util.post(
					"v2/school_job/my_desire_by_userid", {
						user_id: this.user_id
					},
					(res) => {

						if (res.code == 200) {


							this.MyDesireList = res.data
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			getUserRecordInfoByUserId() {
				this.$util.post(
					"v2/school_job/user_record_info_by_userid", {
						user_id: this.user_id
					},
					(res) => {

						if (res.code == 200) {
							this.applyResumeData(res.data)
							if (res.data && res.data.source == 2 && this.id) {
								this.MyDesireList = []
								this.getUserRecordInfo()
							}
							/* legacy parsing retained for rollback reference
							this.info = res.data
							this.introduction_short_video = res.data.introduction_short_video
							if (res.data.certificate) {
								if(res.data.certificate.indexOf('[')!=-1){
									let arr = JSON.parse(res.data.certificate)
									let arr1 = []
									arr.forEach((item) => {
										arr1.push(item.cainfo)
									})
									this.info.certificate = arr1.join('、')
								}else{
									this.info.certificate  = res.data.certificate
								}
								
							}
							if (res.data.job_title) {
								if (this.typeString(res.data.job_title)) {
									this.job_title = (JSON.parse(res.data.job_title)).toString()
								}
							}

							if (res.data.age) {
								if (res.data.age.indexOf('-') > -1) {
									let birthday = res.data.age
									let birth_year = birthday.substring(0, 4)
									let now_yaer = (new Date()).getFullYear()

									this.info.age = now_yaer - birth_year * 1
								}
							}

							if (res.data.practice_experience) {
								this.practice_list = JSON.parse(res.data.practice_experience)
								console.log(this.practice_list)
							}
							if (res.data.social_experience) {
								this.social_list = JSON.parse(res.data.social_experience)
							}

							if (res.data.award_experience) {
								this.award_list = JSON.parse(res.data.award_experience)
							}

							if (res.data.hobby) {
								if (this.typeString(res.data.hobby)) {
									this.interestList = ((JSON.parse(res.data.hobby)).s_by)
								} else {
									this.interestList = res.data.hobby.split('、')
								}
							}

							if (res.data.personal_works) { //个人作品
								let abj = JSON.parse(res.data.personal_works)
								if (abj.text) {
									abj.tet = abj.text.split(';')
								} else {
									abj.tet = []
								}
								this.personal_works = abj
							}
							if (res.data.file_list) {
								this.filelist = res.data.file_list
							}

							*/
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			parseResumeJson(value, fallback) {
				if (typeof value !== 'string') {
					return value === undefined || value === null ? fallback : value
				}
				try {
					return JSON.parse(value)
				} catch (e) {
					return fallback
				}
			},
			formatExperienceDescription(value) {
				if (value === undefined || value === null) {
					return ''
				}

				let content = value
				if (typeof content === 'string') {
					let trimmedContent = content.trim()
					if (trimmedContent.indexOf('[') === 0 || trimmedContent.indexOf('{') === 0) {
						content = this.parseResumeJson(trimmedContent, content)
					}
				}

				if (Array.isArray(content)) {
					content = content.map(item => {
						if (item && typeof item === 'object') {
							let date = [item.date1, item.date2].filter(Boolean).join(' 至 ')
							return [item.entry_name, item.role, item.entry_desc, date].filter(Boolean).join('\n')
						}
						return item
					}).filter(Boolean).join('\n')
				} else if (content && typeof content === 'object') {
					content = content.entry_desc || ''
				}

				return String(content)
					.replace(/<(?:script|style)\b[^>]*>[\s\S]*?<\/(?:script|style)>/gi, '')
					.replace(/\\r\\n|\\n|\\r/g, '\n')
					.replace(/\r\n?|\n/g, '\n')
					.replace(/<br\s*\/?>/gi, '\n')
					.replace(/<\/(?:p|div|li|ul|ol)>/gi, '\n')
					.replace(/<[^>]+>/g, '')
					.replace(/&nbsp;|&#160;/gi, ' ')
					.replace(/&amp;/gi, '&')
					.replace(/&lt;/gi, '<')
					.replace(/&gt;/gi, '>')
					.replace(/&quot;/gi, '"')
					.replace(/&#39;|&apos;/gi, "'")
					.replace(/[ \t]*([•●▪◦])[ \t]*/g, '\n$1 ')
					.replace(/([；;])[ \t]*/g, '$1\n')
					.replace(/([。！？!?])\s*(?=(?:[①-⑳]|\d{1,2}\s*[.．、)）](?=\s*[^\d])|[（(]\s*\d{1,2}\s*[)）]|[一二三四五六七八九十]+\s*、))/g, '$1\n')
					.replace(/[ \t]+(?=(?:[①-⑳]|\d{1,2}\s*[.．、)）](?=\s*[^\d])|[（(]\s*\d{1,2}\s*[)）]|[一二三四五六七八九十]+\s*、))/g, '\n')
					.split('\n')
					.map(line => line.replace(/[ \t]+/g, ' ').trim())
					.filter(Boolean)
					.join('\n')
			},
			applyResumeData(data) {
				data = data || {}
				this.info = data
				if (data.source !== undefined && data.source !== null) {
					this.source = data.source
				}
				this.introduction_short_video = data.introduction_short_video || ''

				if (data.age && typeof data.age === 'string' && data.age.indexOf('-') > -1) {
					this.info.age = new Date().getFullYear() - data.age.substring(0, 4) * 1
				}
				if (data.job_title) {
					let jobTitle = this.parseResumeJson(data.job_title, data.job_title)
					this.job_title = Array.isArray(jobTitle) ? jobTitle.join(',') : jobTitle
				}
				if (data.certificate) {
					let certificate = this.parseResumeJson(data.certificate, data.certificate)
					if (Array.isArray(certificate)) {
						this.info.certificate = certificate.map(item => item.cainfo || item).join(',')
					}
				}
				if (data.hobby) {
					let hobby = this.parseResumeJson(data.hobby, data.hobby)
					if (Array.isArray(hobby)) {
						this.interestList = hobby
					} else if (hobby && typeof hobby === 'object') {
						this.interestList = hobby.s_by || []
					} else if (typeof hobby === 'string') {
						this.interestList = hobby.split(',')
					}
				}
				if (data.personal_works) {
					let works = this.parseResumeJson(data.personal_works, {})
					if (works && typeof works === 'object') {
						works.files = works.files || []
						works.images = works.images || []
						works.tet = works.text ? works.text.split(';') : (works.tet || [])
						this.personal_works = works
					}
				}
				this.filelist = data.file_list || {}
				let practiceList = this.parseResumeJson(data.practice_experience, [])
				let socialList = this.parseResumeJson(data.social_experience, [])
				let awardList = this.parseResumeJson(data.award_experience, [])
				if (Array.isArray(practiceList) && practiceList.length > 0 && (practiceList[0].entry_name || practiceList[0].role || practiceList[0].entry_desc)) {
					this.practice_list = practiceList
				}
				if (Array.isArray(socialList) && socialList.length > 0) {
					this.social_list = socialList
				}
				if (Array.isArray(awardList) && awardList.length > 0 && awardList[0].reward_name) {
					this.award_list = awardList
				}

				if (this.source == 1) {
					this.eduExpList = this.parseResumeJson(data.educational_experience, [])
					this.practice_list = this.parseResumeJson(data.practice_experience, [])
					this.social_list = this.parseResumeJson(data.social_experience, [])
					this.academic_list = this.parseResumeJson(data.academic_experience, [])
					this.award_list = this.parseResumeJson(data.award_experience, [])
					this.eduExpList = Array.isArray(this.eduExpList) ? this.eduExpList : []
					this.practice_list = Array.isArray(this.practice_list) ? this.practice_list : []
					this.social_list = Array.isArray(this.social_list) ? this.social_list : []
					this.academic_list = Array.isArray(this.academic_list) ? this.academic_list : []
					this.award_list = Array.isArray(this.award_list) ? this.award_list : []
				}
			},
			typeString(str) {
				if (typeof str == 'string') {
					try {
						var obj = JSON.parse(str);
						// 等于这个条件说明就是JSON字符串 会返回true
						if (typeof obj == 'object' && obj) {
							return true;
						} else {
							//不是就返回false
							return false;
						}
					} catch (e) {
						return false;
					}
				}
				return false;
			},
			getUserRecordInfo() {
				this.$util.post(
					"v2/school_job/user_record_info", {
						id: this.id
					},
					(res) => {

						if (res.code == 200) {
							this.applyResumeData(res.data)
							/* legacy parsing retained for rollback reference
							this.info = res.data
							this.introduction_short_video = res.data.introduction_short_video
							if (res.data.age) {
								if (res.data.age.indexOf('-') > -1) {
									let birthday = res.data.age
									let birth_year = birthday.substring(0, 4)
									let now_yaer = (new Date()).getFullYear()

									this.info.age = now_yaer - birth_year * 1
								}
							}

							if (res.data.job_title) {
								this.job_title = res.data.job_title
								try {
									this.job_title = JSON.parse(res.data.job_title).join(',')
								} catch (error) {
									//TODO handle the exception
								}
							}

							if (res.data.hobby) {
								if (this.typeString(res.data.hobby)) {
									this.interestList = ((JSON.parse(res.data.hobby)).s_by)
								} else {
									this.interestList = res.data.hobby.split('、')
								}
							}
							*/
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			typeString(str) {
				if (typeof str == 'string') {
					try {
						var obj = JSON.parse(str);
						// 等于这个条件说明就是JSON字符串 会返回true
						if (typeof obj == 'object' && obj) {
							return true;
						} else {
							//不是就返回false
							return false;
						}
					} catch (e) {
						return false;
					}
				}
				return false;
			},

			openFile(url) {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				
				
				if (url.indexOf('http') != -1) {
					window.open(url, '_blank')
				}
			},
			openResumeFile() {
				const item = this.info || {}
				const url = this.filelist && this.filelist.url
				if (!url) return
				if (!this.nextToken) return this.openFile(url)
                return this.openFile(url) 
                return
				this.$axios.post('https://np.sx985.com/v2/readResume', Qs.stringify({
					admin_id: this.schoolInfo.admin_id || '', uid: item.uid || item.user_id || this.user_id || '', url: url,
					name: item.realname || item.username || item.name || '', school_name: item.school_name || item.academy_name || '',
					smajor: item.major_name || item.smajor || item.department || '', edu: item.highest_education || item.edu || item.education || item.degree || '',
					avatar: item.avatar || item.gender || ''
				}), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + (localStorage.getItem('nextToken') || '') } }).then(res => {
					if (Number(res.data && res.data.code) === 200) return this.openFile(url)
					this.resumeRechargeVisible = true
				}).catch(() => { this.resumeRechargeVisible = true })
			},
			goResumeRecharge() { this.resumeRechargeVisible = false; this.$router.push({ path: '/resumeRecharge' }) },
		},
		components: {
			chatView,
			studentAvatar,
		},
	};
</script>
<style>
	#jobDetails .elDialog .el-dialog {
		/* background: initial; */
		box-shadow: initial;
		width: 465px !important;
		margin-top: 1vh !important;
	}

	#jobDetails .elDialog .el-dialog {
		margin: 0 auto 30px;
	}

	#jobDetails .chatView .el-dialog {
		background: initial;
		box-shadow: initial;
		width: 465px !important;
		margin-top: 1vh !important;
	}

	#jobDetails .chatView .el-dialog {
		margin: 0 auto 30px;
	}

	.resume-recharge-reminder.el-dialog { margin-top: 50vh !important; transform: translateY(-50%); border-radius: 12px; overflow: hidden; }
	.resume-recharge-reminder .el-dialog__header { padding: 18px 24px; border-bottom: 1px solid #ebeef5; }
	.resume-recharge-reminder .el-dialog__title { color: #222; font-size: 18px; font-weight: 700; }
	.resume-recharge-reminder .el-dialog__body { padding: 54px 24px 34px; text-align: center; color: #30343b; font-size: 18px; }
	.resume-recharge-reminder .el-dialog__footer { padding: 0 0 30px; text-align: center; }
	.resume-recharge-reminder__footer .el-button { width: 110px; height: 40px; margin: 0 6px; font-size: 15px; }
	.resume-recharge-reminder__footer .el-button:first-child { color: #5f6368; border-color: #cfe5ff; background: #edf7ff; }
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 20px 40px 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.jobInfo {
			padding: 0 40px;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 20px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #000;
				}
			}

			.chunk {
				width: 722px;
				background: #F6F7FB;
				border-radius: 10px;
				padding: 15px 30px;
				margin-bottom: 10px;

				.nameContainer {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.left {
						.name {
							font-weight: bold;
							font-size: 16px;
							color: #333;
							margin-bottom: 15px;
						}

						.school {
							font-weight: 500;
							font-size: 14px;
							color: #333333;
						}

					}

					.right {
						font-size: 0;
						width: 57px;
						height: 57px;
						img {
							width: 57px;
							height: 57px;
							border-radius: 50%;
						}
					}
				}

				.programme {
					.programmeTitle {
						font-weight: bold;
						font-size: 16px;
						color: #333;
						margin-bottom: 15px;
					}

					.tags {
						display: flex;
						align-items: center;
						margin-bottom: 30px;

						.item {
							display: flex;
							align-items: center;
							font-size: 0;
							margin-right: 10px;

							img {
								width: 15px;
								height: 15px;
								margin-right: 5px;
							}

							div {
								font-weight: 500;
								font-size: 14px;
								color: #767676;
							}
						}
					}
				}

				.projectMain {
					font-weight: 500;
					font-size: 14px;
					color: #767676;
					line-height: 30px;
					margin-top: 20px;
				}

				.experienceDescription {
					white-space: pre-line;
				}

				.intention {
					.name {
						font-weight: bold;
						font-size: 16px;
						color: #333;
						margin-bottom: 15px;
					}

					.tags {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						justify-content: space-between;

						.item {
							font-weight: 500;
							font-size: 14px;
							color: #767676;
							margin-right: 20px;
							margin-bottom: 10px;
						}
					}
				}

				.intention1 {
					.name {
						font-weight: bold;
						font-size: 16px;
						color: #333;
						margin-bottom: 15px;
					}

					.intentionItem {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: 1px solid #e5e5e5;
						padding: 10px 0;

						.left {
							.top {
								display: flex;
								align-items: center;
								margin-bottom: 10px;

								.a1 {
									font-weight: 500;
									font-size: 14px;
									color: #000;
									margin-right: 5px;
								}

								.a2 {
									font-weight: 500;
									font-size: 14px;
									color: #000;
								}
							}

							.bottom {
								display: flex;
								align-items: center;

								.xian1 {
									height: 15px;
									border-right: 1px solid #767676;
									margin: 0 10px;
								}

								.a3 {
									font-weight: 500;
									font-size: 14px;
									color: #767676;
								}

								.a4 {
									font-weight: 500;
									font-size: 14px;
									color: #767676;
								}
							}
						}

						.right {
							border-radius: 5px;
							padding: 10px 10px;

							font-weight: bold;
							font-size: 14px;
							color: #FFFFFF;
							background: #FF6600;
							cursor: pointer;
						}
					}
				}

				.imgList {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					font-size: 0;

					img {
						margin: 0 10px 10px 0;
						width: 104px;
						height: 104px;
						border-radius: 10px;
						background: #225AC4;
					}
				}

			}

			.btnContainer {
				width: 722px;
				display: flex;
				justify-content: flex-end;
				padding-bottom: 20px;

				.btn {
					width: 134px;
					height: 45px;
					background: #0084FF;
					border-radius: 10px;

					text-align: center;
					line-height: 45px;
					cursor: pointer;

					font-weight: 500;
					font-size: 18px;
					color: #FFFFFF;
				}
			}

		}
	}



	.shortVideo {
		position: absolute;
		bottom: -12px;
		left: 50%;
		transform: translate(-50%);
		z-index: 30;

		width: 50px;
		text-align: center;
		font-size: 11px;
		font-weight: 400;
		color: #222222;
		border: 1px solid #FEA265;
		background: #FDF6E6;
		border-radius: 20px;
		padding: 5px 0;
	}


	.elDialog {
		width: 100%;

		.searchItem {
			// display: flex;
			// align-items: center;
			// margin-right: 15px;
			margin-bottom: 20px;
			border-bottom: 1px solid #E5E5E5;
			padding: 0 0 20px 0;

			.iptName {
				// width: 80px;
				// text-align: right;
				font-weight: 400;
				font-weight: bold;
				font-size: 16px;
				color: #333;
				margin-bottom: 10px;

			}

			.preference {
				font-size: 16px;
				color: #343232;
				font-weight: 500;
			}

		}

		.advanced {

			margin-bottom: 20px;
			margin-top: 30px;
		}
	}

	.img-carousel-box {
		width: 100%;
		height: 650px;

		img {
			display: block;
			max-width: 100%;
			margin: 0 auto;
			height: 600px;
			
		}
	}
	
</style>
